import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Image from "../../../../app/assets/images/icons/notFound.svg";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { useMediaQuery } from "@mui/material";

const NotFound = () => {
  const i18nLocale = useSelector((state) => state.i18nLocale);
  const navigate = useNavigate();
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: isDesktop ? "flex-start" : "center",
        paddingTop: isDesktop ? "64px" : "0",
        gap: 4,
        textAlign: "center",
      }}
    >
      <Box component="img" src={Image} alt="404 Not Found" sx={{ maxWidth: "400px", mb: 4 }} />
      <Typography variant="h5">
        <FormattedMessage id="page_not_found" defaultMessage="Page Not Found" />
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate(`/${i18nLocale}/`)}
        sx={{
          backgroundColor: "#166D4C",
          color: "white",
          borderRadius: "29px",
          px: { xs: 6, md: 10 },
          py: 1.5,
          fontSize: "14px",
          fontFamily: "Segoe UI Regular, sans-serif",
          textTransform: "none",
          whiteSpace: "nowrap",
          "&:hover": { backgroundColor: "#135a3d" },
        }}
      >
        <FormattedMessage id="go_home" defaultMessage="Go Home" />
      </Button>
    </Box>
  );
};

export default NotFound;